<!--
 * @Descripttion: 
 * @Author: juanjuanhui
 * @Date: 2022-01-18 14:32:53
 * @LastEditors: quwandong
 * @LastEditTime: 2022-08-15 15:17:30
-->
<template>
  <el-main>
    <div class="top-wrap">
      <Bread></Bread>
      <el-row type="flex" justify="space-between">
        <div class="top-filter">
          <el-form
            ref="filterForm"
            :inline="true"
            :model="filterForm"
            class="filter-form"
          >
            <el-form-item prop="fullName">
              <el-input
                v-model="filterForm.fullName"
                placeholder="人员姓名"
                @keyup.enter.native="handleFilterPro"
              ></el-input>
            </el-form-item>
            <el-form-item prop="loginName">
              <el-input
                v-model="filterForm.loginName"
                @keyup.enter.native="handleFilterPro"
                placeholder="登录账号"
              ></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleFilterPro"
                >查询</el-button
              >
              <el-button
                type="primary"
                plain
                @click="handleResetFilter('filterForm')"
                ><i class="el-icon-refresh-right"></i>清空</el-button
              >
            </el-form-item>
          </el-form>
        </div>
        <div class="btn-panle">
          <el-button
            @click="handleAddAccount"
            type="primary"
            icon="el-icon-plus"
            >新增人员账号
          </el-button>
        </div>
      </el-row>
    </div>
    <div class="main">
      <el-table
        :data="accounts"
        v-loading="accountLoad"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column label="序号" width="80" align="center">
          <template slot-scope="scope">
            {{
              (pagination.currentPage - 1) * pagination.pageSize +
              (scope.$index + 1)
            }}
          </template>
        </el-table-column>
        <el-table-column
          label="人员姓名"
          min-width="10%"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">
            {{ scope.row.fullName }}
            <span v-if="scope.row.isOneself" class="tag"
              >（是本人）</span
            ></template
          >
        </el-table-column>
        <el-table-column
          prop="loginName"
          label="登录账号"
          min-width="10%"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{ scope.row.loginName }}</template>
        </el-table-column>
        <el-table-column
          label="角色权限"
          min-width="20%"
          align="center"
          show-overflow-tooltip
        >
          <template slot-scope="scope">{{ scope.row.roleNames }}</template>
        </el-table-column>
        <el-table-column
          prop="created"
          label="新增时间"
          min-width="15%"
          align="center"
          show-overflow-tooltip
        >
        </el-table-column>
        <el-table-column
          fixed="right"
          label="操作"
          min-width="20%"
          align="center"
        >
          <template slot-scope="scope">
            <el-button type="text" @click="handleLookAuth(scope.row)"
              >查看权限
            </el-button>
            <el-button
              type="text"
              @click="handleRemoveAccount(scope.row)"
              :disabled="scope.row.isOneself"
              >删除账号
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        background
        layout="total,prev, pager, next,jumper"
        :page-size="this.pagination.pageSize"
        :total="pagination.recordTotal"
        :hide-on-single-page="true"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
    <!-- 查看权限弹窗 -->
    <DialogAuth
      v-if="dialogAuthVisible"
      :dialogAuthVisible="dialogAuthVisible"
      :curAccount="curAccount"
      :defaultProps="defaultProps"
      :ownAuthData="ownAuthData"
      @close="close"
      @showAccount="showAccount"
      :type="1"
    ></DialogAuth>
    <!-- 删除账号弹窗 -->
    <el-dialog
      class="dialog-bg dialog-remove-account"
      title="删除账号"
      :visible.sync="dialogRemoveAccountVisible"
      width="480px"
    >
      <div class="tip"><i class="el-icon-warning"></i>请谨慎操作</div>
      <div class="con">
        是否确认删除<span>{{
          curAccount.loginName + ' ' + curAccount.fullName
        }}</span
        >的登录账号
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogRemoveAccountVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSaveRemoveAccount"
          >删除</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      class="dialog-bg dialog-auth"
      title="修改角色"
      :visible.sync="showAccountDialog"
      width="760px"
    >
      <div class="con-wrap">
        <el-form
          :model="editData"
          :rules="rules"
          label-width="90px"
          ref="editData"
        >
          <el-form-item label="人员姓名：" prop="fullName">
            <el-col class="col">
              {{ editData.fullName }}
            </el-col>
          </el-form-item>
          <el-form-item label="登录账号：" prop="loginName">
            <el-col class="col">
              {{ editData.loginName }}
            </el-col>
          </el-form-item>
          <el-form-item
            label="选择角色权限"
            label-width="120px"
            prop="roleIdList"
          >
            <el-col class="col col-360">
              <el-checkbox-group
                v-model.trim="editData.roleIdList"
                @change="handleChangeRoleList"
              >
                <el-checkbox
                  v-for="item in roles"
                  :key="item.id"
                  :label="item.id"
                  name="roleIds"
                  >{{ item.roleName }}</el-checkbox
                >
              </el-checkbox-group>
            </el-col>
          </el-form-item>
        </el-form>
        <div class="auth-panel" v-if="editData.roleIdList.length > 0">
          <div class="con">
            <h4 class="title"><i class="left"></i>该账号将具有的权限</h4>
            <el-tree
              v-loading="authLoading"
              class="auth-tree"
              :data="authData"
              :props="defaultProps"
              accordion
            >
            </el-tree>
          </div>
        </div>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="showAccountDialog = false">取消</el-button>
        <el-button type="primary" @click="editAccount">确定</el-button>
      </span>
    </el-dialog>
  </el-main>
</template>

<script>
import DialogAuth from './components/DialogAuth'
export default {
  name: 'AccountManagement',
  data() {
    return {
      filterForm: {
        fullName: '', // 人员姓名
        loginName: '', // 登录账号
      },
      allFilters: {},
      accounts: [],
      accountLoad: false,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        recordTotal: 0,
      },
      filterFormMember: {
        key: '',
      },
      ruleForm: {
        id: '',
        mobile: '',
        ruleForm: '',
      },
      passwordRuleForm: {
        id: '',
        mobile: '',
        name: '',
        password: '',
        surePassword: '',
      },
      rules: {
        roleIdList: [
          { required: true, message: '请选择角色', trigger: 'blur' },
        ],
      },
      dialogPasswordVisible: false, // 修改密码
      dialogInfoVisible: false, // 修改信息
      dialogAuthVisible: false, // 查看权限
      dialogRemoveAccountVisible: false, // 删除账号
      showAccountDialog: false, // 修改账号
      authData: [],
      ownAuthData: [],
      defaultProps: {
        children: 'children',
        label: 'menuName',
      },
      curRole: '',
      curAccount: {
        roleIdList: [],
      },
      editData: {
        roleIdList: [],
      },
      roles: [],
      authLoading: false,
    }
  },
  components: { DialogAuth },
  mounted() {
    this.getAccountList()
  },
  methods: {
    close(type) {
      this[type] = false
    },
    async editAccount() {
      try {
        let { status } = await this.$http.account.updateRoleInfo({
          accountId: this.editData.id,
          roleIds: Array.from(new Set(this.editData.roleIdList)),
        })
        if (status == 1) {
          this.showAccountDialog = false
          this.$message({
            type: 'success',
            message: '修改角色成功',
            duration: 2000,
          })
          this.getAccountList()
        }
      } catch (error) {
        console.log(error)
      }
    },
    /**
     * @descripttion: 选择角色
     * @Author: juanjuanhui
     * @Date: 2022-02-17 17:00:14
     * @param {*} data 已选项
     */
    handleChangeRoleList(data) {
      this.authLoading = true
      this.authData = []
      if (data && data.length > 0) {
        let params = {
          roleIdList: data,
        }
        this.$http.common
          .selectOwnSMenuTree(params)
          .then((res) => {
            this.authData = res.data
            this.authLoading = false
          })
          .catch(() => {
            this.authLoading = false
          })
      }
    },
    getRoleList() {
      let params = {
        roleType: 2,
      }
      this.$http.account.getAllSRoleList(params).then((res) => {
        this.roles = res.data
      })
    },
    /**
     * @descripttion: 查询机具
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:07:16
     */
    handleFilterPro() {
      this.pagination.currentPage = 1
      this.getAccountList()
    },
    /**
     * @descripttion: 重置筛选条件
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:08:07
     * @param {String} formName 表单ref名称
     */
    handleResetFilter(formName) {
      this.$refs[formName].resetFields()
      this.pagination.currentPage = 1
      this.getAccountList()
    },
    /**
     * @descripttion: 获取查询参数
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:06:58
     */
    getAllFilters() {
      this.allFilters = { ...this.filterForm }
    },
    /**
     * @descripttion: 获取账号列表
     * @Author: juanjuanhui
     * @Date: 2022-02-23 11:41:48
     */
    getAccountList() {
      this.getAllFilters()
      let { currentPage, pageSize } = this.pagination
      let params = { currentPage, pageSize }
      Object.assign(params, params, this.allFilters)
      this.accountLoad = true
      this.$http.account
        .getManageAccount(params)
        .then((res) => {
          let { recordTotal, content: accounts } = res.data
          this.pagination.recordTotal = recordTotal
          this.accounts = accounts
          this.accountLoad = false
        })
        .catch(() => {
          this.accountLoad = false
        })
    },
    /**
     * @descripttion: 切换分页
     * @Author: juanjuanhui
     * @Date: 2021-06-23 22:14:09
     * @param {Number} val 当前页码
     */
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getAccountList()
    },
    /**
     * @descripttion: 添加账号
     * @Author: juanjuanhui
     * @Date: 2022-01-18 15:09:07
     */
    handleAddAccount() {
      this.$router.push({ path: '/setting/account-management/add' })
    },
    /**
     * @descripttion: 修改密码
     * @Author: juanjuanhui
     * @Date: 2022-02-15 17:35:16
     * @param {*}item 当前数据项
     */
    handleEditPassword(item) {
      this.passwordRuleForm = JSON.parse(JSON.stringify(item))
      this.dialogPasswordVisible = true
    },
    /**
     * @descripttion: 保存修改的密码
     * @Author: juanjuanhui
     * @Date: 2022-02-15 19:40:56
     * @param {*} formName
     * @return {*}
     */
    handleSavegPassword(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let { id, password, surePassword } = this.passwordRuleForm
          let params = {
            id,
            passwordFirst: password,
            passwordSecond: surePassword,
          }
          this.$http.account.updateAccountPwd(params).then(() => {
            this.dialogPasswordVisible = false
          })
        } else {
          return false
        }
      })
    },
    /**
     * @descripttion: 修改信息
     * @Author: juanjuanhui
     * @Date: 2022-01-18 15:19:33
     * @param {*} item 当前数据项
     */
    handleEditInfo(item) {
      this.ruleForm = JSON.parse(JSON.stringify(item))
      this.dialogInfoVisible = true
    },
    /**
     * @descripttion: 保存修改的信息
     * @Author: juanjuanhui
     * @Date: 2022-01-19 01:19:40
     * @param {*}
     * @return {*}
     */
    handleSaveInfo() {
      let { id, fullName } = this.ruleForm
      let params = {
        id,
        fullName,
      }
      this.$http.account.updateAccountInfo(params).then(() => {
        this.dialogInfoVisible = false
        this.getAccountList()
      })
    },
    /**
     * @descripttion: 查看权限
     * @Author: juanjuanhui
     * @Date: 2022-03-02 17:46:59
     * @param {*} item
     */
    handleLookAuth(item) {
      item.roleIdList = item.roleIdList ? item.roleIdList : []
      this.curAccount = item
      this.dialogAuthVisible = true
      this.ownAuthData = []
      let { roleIdList } = item
      if (roleIdList && roleIdList.length > 0) {
        roleIdList.forEach((item, index) => {
          this.getSelectOwnMenuTree({ roleIdList: [item], index })
        })
      }
    },
    /**
     * @descripttion: 获取某角色的权限
     * @Author: juanjuanhui
     * @Date: 2022-02-22 19:54:22
     * @param {*}
     */
    async getSelectOwnMenuTree(params) {
      let { roleIdList, index } = params
      let arr = this.curAccount.roleNames.split(',')
      try {
        let { data } = await this.$http.common.selectOwnSMenuTree({
          roleIdList,
        })
        this.ownAuthData.push({
          roleName: arr[index],
          authData: data,
        })
      } catch (error) {
        console.log(error)
      }
    },

    /**
     * @descripttion: 删除账号
     * @Author: juanjuanhui
     * @Date: 2022-02-15 20:24:15
     * @param {*} item
     * @return {*}
     */
    async handleRemoveAccount(item) {
      this.curAccount = item
      this.dialogRemoveAccountVisible = true
    },
    /**
     * @descripttion: 确认删除账号
     * @Author: juanjuanhui
     * @Date: 2022-02-15 20:26:37
     * @param {*}
     */
    handleSaveRemoveAccount() {
      this.$http.account
        .delManageAccount({ id: this.curAccount.id })
        .then((res) => {
          if (res.status == 1) {
            this.$message({
              type: 'success',
              message: '删除账号成功',
              duration: 2000,
            })
            this.dialogRemoveAccountVisible = false
            this.getAccountList()
          }
        })
    },
    /**
     * @description: 展示修改账号窗口
     * @Author: yangsibo
     * @Date: 2022-06-01 09:00:19
     * @return {*}
     */
    showAccount() {
      this.editData = JSON.parse(JSON.stringify(this.curAccount))
      this.getRoleList()
      this.handleChangeRoleList(this.editData.roleIdList)
      this.dialogAuthVisible = false
      this.showAccountDialog = true
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@/styles/common.scss';
.main {
  .top-filter {
    display: flex;
    justify-content: space-between;
  }
  .btn-panle {
    margin-top: 6px;
    margin-bottom: 12px;
  }
  .el-table {
    .tag {
      color: #ff0000;
    }
    .el-button {
      padding: 5px 0;
    }
  }
}
::v-deep {
  .el-dialog {
    .el-dialog__footer {
      padding-top: 0;
      text-align: center;
    }
  }
  .dialog-info {
    .el-dialog__body {
      padding: 10px 20px;
      .tip {
        color: #018388;
        margin-bottom: 10px;
        i {
          margin-right: 5px;
        }
      }
      .el-form {
        margin: 0 30px;
        .el-form-item {
          &:first-child {
            margin-bottom: 0;
          }
        }
      }
    }
  }
  .dialog-password {
    .el-dialog__body {
      padding: 10px 20px;
      .tip {
        color: #018388;
        margin-bottom: 10px;
        i {
          margin-right: 5px;
        }
      }
      .el-form {
        .el-form-item {
          &:first-child {
            margin-bottom: 0;
            .el-form-item__label,
            .el-form-item__content {
              line-height: 20px;
            }
          }
          &:nth-child(2) {
            margin-bottom: 0;
          }
          .tips {
            font-size: 14px;
            line-height: 20px;
            color: #acacac;
          }
        }
      }
    }
  }
  .dialog-auth {
    .el-dialog__body {
      padding: 20px 30px;
      .list {
        .item {
          display: flex;
          line-height: 35px;
          color: #222222;
          font-size: 16px;
          .right-side {
            flex: 1;
            .auth-panel {
              margin-bottom: 10px;
              &.active {
                background-color: #ffffff;
                border-radius: 3px;
                border: solid 1px #daf3f3;
                .role {
                  color: #018388;
                  background-color: #f1fafa;
                  i {
                    color: #018388;
                  }
                }
              }
              .role {
                display: flex;
                align-items: center;
                justify-content: space-between;
                height: 40px;
                padding: 0 10px;
                color: #222222;
                background-color: #f8f8f8;
                border-radius: 3px;
                cursor: pointer;
                i {
                  color: #999;
                  font-size: 16px;
                }
                label {
                  margin-left: 5px;
                }
              }
              .el-tree {
                min-height: 100px;
                max-height: 300px;
                overflow-y: auto;
              }
            }
          }
          .delete-side {
            width: 110px;
            height: 36px;
            background: #e9f6f6;
            border-radius: 3px;
            margin-left: 15px;
            font-size: 16px;
            color: #018388;
            text-align: center;
            line-height: 36px;
            cursor: pointer;
          }
          .auth {
            width: 310px;
            max-height: 300px;
            padding-top: 10px;
            margin-top: 5px;
            overflow-y: auto;
            background-color: #ffffff;
            border-radius: 2px;
            border: solid 1px #e5e6eb;
            display: flex;
            box-sizing: border-box;
            &:first-child {
              margin-right: 20px;
            }
          }
          .select-auth {
            margin: 5px 0 0 40px;
          }
        }
      }
      .col-360 {
        width: 300px;
      }
      .con-wrap {
        display: flex;
        .el-form {
          width: 600px;
          margin-right: 10px;
        }
        .auth-panel {
          .con {
            width: 277px;
            border-radius: 2px;
            border: solid 1px #e5e6eb;
            .title {
              position: relative;
              height: 40px;
              padding: 0 16px;
              line-height: 40px;
              background-color: #fbfbfb;
              border-bottom: solid 1px #e5e6eb;
              font-size: 16px;
              color: #222222;
              .left {
                position: absolute;
                top: 13px;
                left: -8px;
                width: 14px;
                height: 14px;
                border-top: 1px solid #e5e6eb;
                border-right: 1px solid #e5e6eb;
                transform: rotate(-135deg);
                background: #fbfbfb;
              }
            }
            .el-tree {
              color: #222222;
              max-height: 300px;
              overflow-y: auto;
              & > .el-tree-node {
                min-height: 40px;
                border-top: solid 1px #e5e6eb;
                &:first-child {
                  border-top: none;
                }
                .el-tree-node__content {
                  height: 40px;
                }
              }
              & > .el-tree-node:last-child {
                border-bottom: none;
              }
            }
          }
        }
      }
    }
  }
  .dialog-remove-account {
    .el-dialog__header {
      padding: 0;
      text-align: center;
      .el-dialog__title {
        font-size: 22px;
        color: #242424;
        font-weight: 400;
      }
    }
    .el-dialog__body {
      padding: 20px 0;
      .title {
        font-size: 22px;
        color: #242424;
        text-align: center;
      }
      .tip {
        display: flex;
        align-items: center;
        height: 35px;
        padding: 0 23px;
        color: #ff8400;
        background-color: #fff7ef;
        .el-icon-warning {
          margin-right: 5px;
        }
      }
      .con {
        padding: 20px 50px;
        font-size: 20px;
        color: #444444;
        span {
          color: #018388;
        }
      }
    }
  }
}
</style>
